import { Car, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";
import BtnNavigateBack from "@/components/ui/btn_navigate_back";
import { useShowNavigateBack } from "@/hooks/useShowNavigateBack";
import { useLanguage } from "@/context/LanguageContext";
import { listOrValueLabels } from "@/i18n";

const ListOrValueCar = () => {
  const navigate = useNavigate();
  const showPageBack = useShowNavigateBack();
  const { language } = useLanguage();
  const labels = listOrValueLabels(language);

  return <div className="min-h-screen relative overflow-hidden">
    <div className="container mx-auto p-6 relative z-10">
      {showPageBack && <BtnNavigateBack />}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-12">
          <h2 className="text-center text-2xl font-semibold mb-6">{labels.title}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="rounded-xl overflow-hidden cursor-pointer h-[180px] relative group" onClick={() => navigate('/car-valuation')}>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-green-500" />
              <div className="relative z-10 h-full p-6 flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <h3 className="text-xl font-semibold text-white">{labels.valuation.title}</h3>
                  <div className="rounded-full bg-white/20 p-2 group-hover:scale-110 transition-transform">
                    <Car className="h-5 w-5 text-white" />
                  </div>
                </div>
                <p className="text-white/90 text-sm mt-auto">
                  {labels.valuation.description}
                </p>
              </div>
            </div>

            <div className="rounded-xl overflow-hidden cursor-pointer h-[180px] relative group" onClick={() => navigate('/car-post-an-ad')}>
              <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-pink-300" />
              <div className="relative z-10 h-full p-6 flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <h3 className="text-xl font-semibold text-white">{labels.listing.title}</h3>
                  <div className="rounded-full bg-white/20 p-2 group-hover:scale-110 transition-transform">
                    <FileText className="h-5 w-5 text-white" />
                  </div>
                </div>
                <p className="text-white/90 text-sm mt-auto">
                  {labels.listing.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
};
export default ListOrValueCar;